import styled from 'styled-components'

import { theme } from '@/theme'

export const Input = styled.input<{
  asTextInput?: boolean
  hasPostfix?: boolean
  $error?: boolean
}>`
  width: 100%;
  min-height: 48px;
  padding: 9px ${({ asTextInput }) => (asTextInput ? '14px' : '40px')} 9px
    ${({ hasPostfix }) => (hasPostfix ? '16px' : '40px')};
  text-align: ${({ asTextInput }) => (asTextInput ? 'left' : 'center')};

  border: none;
  outline-color: transparent;
  outline-offset: 1px;

  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  font-family: ${theme.fonts.mainFont};
  color: ${({ readOnly, disabled }) =>
    readOnly || disabled ? theme.colors.slateGray : theme.colors.sapphireDark};

  border: 1px solid
    ${({ $error }) => ($error ? theme.colors.error : theme.colors.crystalBay)};
  border-radius: 8px;

  transition-duration: ${theme.animationSpeed.medium};

  :focus {
    border-color: ${theme.colors.sapphireDark};
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
  }

  :disabled {
    background: ${theme.colors.catskillWhite};
  }
`

export const Button = styled.button`
  width: 30px;
  height: 30px;
  border: none;

  position: absolute;
  color: ${theme.colors.lavenderSteel};
  top: 50%;
  transform: translateY(-50%);

  background-color: ${theme.colors.white};

  border-radius: 4px;

  transition-duration: ${theme.animationSpeed.medium};

  &:disabled {
    cursor: default;
    background-color: ${theme.colors.catskillWhite};
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${theme.colors.catskillWhite};
  }

  &:active {
    ::before,
    ::after {
      width: 8px;
    }
  }

  &::before,
  &::after {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;

    width: 10px;
    height: 1px;

    background-color: ${theme.colors.slateGray};
    border-radius: 4px;

    transition-duration: ${theme.animationSpeed.medium};
    transform: translate3d(-50%, -50%, 0);
  }
`

export const ButtonIncrease = styled(Button)`
  right: 5px;

  &::after {
    transform: translate3d(-50%, -50%, 0) rotate(90deg);
  }
`

export const ButtonDecrease = styled(Button)`
  left: 5px;
`

export const Wrapper = styled.div`
  position: relative;
`

export const AmountSelector = styled.div``

export const Postfix = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`
